// Lib
import React from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { refreshPageAndClearLocalCache } from '../../../reducers/navigationActions';
import { intercomShowMessages } from '../../../analytics/analyticsActions';

// Components
import ModalActionsList from '../../modal/ModalActionsList';

// Constants
import LinkButton from '../../buttons/LinkButton';

const TimeoutErrorContent: React.FC = () => {
    const dispatch = useDispatch();

    const actions = [
        {
            text: 'Try again',
            func: (event: Event) => {
                event.preventDefault();
                dispatch(refreshPageAndClearLocalCache());
            },
        },
    ];

    return (
        <>
            <h2>Something went wrong</h2>
            <div>
                <p>
                    For some reason it&apos;s taking an unusually long time to load your content. This often resolves
                    itself after a few minutes — please try again soon.
                </p>
                <ModalActionsList actions={actions} />
            </div>
            <div className="section">
                <p>
                    Need help? <LinkButton onClick={() => dispatch(intercomShowMessages())}>Contact support</LinkButton>
                </p>
            </div>
        </>
    );
};

export default TimeoutErrorContent;
